module.exports = __webpack_public_path__ + "static/img/qi.d288f88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/manman/images/qi.jpg
// module id = R94H
// module chunks = 21